module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "illustration",
    attrs: {
      "id": "illustration"
    }
  }, [_c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Illustrations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterA"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("(Appearing between pages 168 and 169)")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("THE AUTHOR, 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("FAMOUS GERMAN AIR FIGHTERS AND MR. FOKKER")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Fokker, Udet, von Scheich, von Richthofen, Immelman, Boelcke, Voss")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("BALLOON STRAFFING")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("FAMOUS BRITISH AIR FIGHTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Maxwell, Rees, Mulholland, Hawker, Lloyd, Windsor, MacDonald, Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("FAMOUS BRITISH AIR FIGHTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Van Ryneveld, Rhys-David, Longcroft, Ball, Kinkead, Caldwell, Strange")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("H.M. THE KING CHATTING TO PILOTS OF NO. 74 SQUADRON")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("FAMOUS BRITISH AIR FIGHTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Sowrey, Beauchamp-Proctor, Barker, McCudden, Bowman, Crowe, Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("FAMOUS FRENCH AIR FIGHTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Guynemer, Nungessor, Dormé, Madon, Foncke, Coppens")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("VOSS’S LAST FIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterB-1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e367dd22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofAirfighters_illustration.vue
// module id = 69
// module chunks = 0